import React, { useEffect } from "react";
import "../components/allpages.css";
import useEncryption from "../../../services/useEncryption";
import { convertToUSFormat } from "../../../helpers/utils";
import {
  above13AgeQuestionsBVDQ,
  age4to8QuestionsBVDQ,
  age9to13QuestionsBVDQ,
  age4to8QuestionsHistory,
  above13AgeQuestionsHistory,
  age9to13QuestionsHistory,
  // initialQuestionsData,
} from "../../../helpers/questions";

export default function PdfTemplate({ patientData, notesData }) {
  const { decryptData } = useEncryption();
  const answers = decryptData(patientData?.formsortResponse)?.answers;
  const formsortResponse = decryptData(patientData?.formsortResponse);




  const symptomKeyMap = {
    Dizziness: "dizziness",
    Nausea: "nausea",
    Anxiety: "anxiety",
    Headaches: "headache",
    "Neck Pain": "neck_pain",
    "Unsteady with Walking": "balance_issues",
    "Sensitivity to Light": "light_sensitivity",
    "Reading Difficulty": "reading_challenges",
    "Sound Sensitivity": "sound_sensitivity",
  };
  useEffect(() => { }, [notesData]);

  return (
    <div>
      <div className="d-flex">
        <div className="col-lg-4 p-3 border-right">
          <div
            className="mb-2"
            style={{ border: "1px solid", padding: "10px" }}
          >
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              Patient Details
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>First Name:</span>
              <span>{answers?.name || answers?.Enter_firstname || answers?.Enter_firstname2}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Last Name:</span>
              <span>{answers?.Enter_lastname || answers?.Enter_lastname || answers?.Enter_lastname}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Phone Number:</span>
              <span>{answers?.phone_number}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Email:</span>
              <span>{answers?.email_address || answers?.email_address_2 || answers?.email_address_3 || answers?.email_address_4}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Age:</span>
              <span>{answers?.age}</span>
            </div>
            {/* <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Backup Phone:</span>
              <span>{answers?.backup_phone_number}</span>
            </div> */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Preferred Contact Method:</span>
              <span>{answers?.phone_number_preferred_contact_met || answers?.preferred_contact_method}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>City</span>
              <span>{answers?.city}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>State</span>
              <span>{answers?.state}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Country:</span>
              <span>{answers?.country_of_residence || answers?.country_of_residence_}</span>
            </div>
             <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>ZipCode:</span>
              <span>{answers?.zipCode}</span>
            </div>
            {/* <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Tags:</span>
              <span>{formsortResponse?.tags?.join(", ")}</span>
            </div> */}
            <div style={{ fontSize: "14px" }}>
              <strong>Tags:</strong>{" "}


              {formsortResponse?.tags?.map((tag, i) => (
                <span
                  key={i}
                  style={{
                    display: "inline-block",
                    background: "#f0f0f0",
                    borderRadius: "12px",
                    padding: "4px 10px",
                    margin: "0 5px 5px 0",
                    fontSize: "13px"
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>


            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Locations:</span>
              <span>{patientData?.organizationName}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Date Time:</span>
              <span>{convertToUSFormat(patientData?.created_at)}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Patient Id:</span>
              <span>{patientData?.patientId}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Status:</span>
              <span>{patientData?.status}</span>
            </div>
          </div>

          <div
            className="mb-2"
            style={{ border: "1px solid", padding: "10px" }}
          >
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              BVDQ Score
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
              }}
            >
              <span>{patientData?.bvdqScores}</span>
            </div>
          </div>

          <div
            className="mb-2"
            style={{ border: "1px solid", padding: "10px" }}
          >
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              SSI Score
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
              }}
            >
              <span>{answers?.ssi_scores}</span>
            </div>
          </div>

          <div
            className="mb-2"
            style={{ border: "1px solid", padding: "10px" }}
          >
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              Level of Discomfort
            </div>
            {Object.keys(symptomKeyMap).map((displayName) => {
              const answerKey = symptomKeyMap[displayName];
              if (answers && answers[answerKey] !== undefined) {
                return (
                  <div
                    key={answerKey}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "12px",
                    }}
                  >
                    <span>{displayName}:</span>
                    <span>{answers[answerKey]}</span>
                  </div>
                );
              }
              return null;
            })}
          </div>

          <div
            className="mb-2"
            style={{ border: "1px solid", padding: "10px" }}
          >
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              Health History
            </div>
            {answers?.above13age_bvdq_scores ? (
              above13AgeQuestionsHistory.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "12px",
                  }}
                >
                  <span>{item.question}</span>
                  <span>{answers?.[item.key]}</span>
                </div>
              ))
            ) : answers?.["4to8age_bvdq_scores"] ? (
              age4to8QuestionsHistory.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "12px",
                  }}
                >
                  <span>{item.question}</span>
                  <span>{answers?.[item.key]}</span>
                </div>
              ))
            ) : answers?.["9to13age_bvdq_scores"] ? (
              age9to13QuestionsHistory.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "space-between",
                    fontSize: "12px",
                  }}
                >
                  <span>{item.question}</span>
                  <span>{answers?.[item.key]}</span>
                </div>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "12px",
                }}
              >
                <span>No health history available</span>
              </div>
            )}
          </div>
        </div>

        <div className="col-lg-8 p-3">
          <div
            className="mb-2"
            style={{ border: "1px solid", padding: "10px" }}
          >
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              Symptom Frequency
            </div>
            {answers?.above13age_bvdq_scores ? (
              above13AgeQuestionsBVDQ.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "12px",
                  }}
                >
                  <span>{item.question}</span>
                  <span>{answers?.[item.key]}</span>
                </div>
              ))
            ) : answers?.["4to8age_bvdq_scores"] ? (
              age4to8QuestionsBVDQ.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "12px",
                  }}
                >
                  <span>{item.question}</span>
                  <span>{answers?.[item.key]}</span>
                </div>
              ))
            ) : answers?.["9to13age_bvdq_scores"] ? (
              age9to13QuestionsBVDQ.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "12px",
                  }}
                >
                  <span>{item.question}</span>
                  <span>{answers?.[item.key]}</span>
                </div>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "12px",
                }}
              >
                <span>No symptom frequency data available</span>
              </div>
            )}
          </div>
          <div
            className="mb-2"
            style={{ border: "1px solid", padding: "10px" }}
          >
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              Feedback on the BVDQ™ Assessment
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Discovered BVDQ™ Assessment via</span>
              <span>
                {answers?.find_bvdq_assessment
                  ? {
                      internet_search: "Internet Search",
                      facebook: "Facebook",
                      instagram: "Instagram",
                      tiktok: "TikTok",
                      forum_or_blog: "Forum or Blog",
                      referred_by_a_friend: "Referred by a Friend",
                      referred_by_a_professional: "Referred by a Professional",
                      youtube: "YouTube",
                    }[answers.find_bvdq_assessment] || answers.find_bvdq_assessment
                  : "No Feedback Available"}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
              <span>Additional Feedback</span>
              <span>
                {answers?.source_of_discovery
                  ? answers.source_of_discovery
                  : "No Feedback Available"}
              </span>
            </div>
          </div>

          <div
            className="mb-2"
            style={{ border: "1px solid", padding: "10px" }}
          >
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              Additional Comments
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "12px",
              }}
            >
               <span>
                {answers?.comment_section_optional || answers?.comment_section_optional_youth ? (
                  <>
                    {answers?.comment_section_optional && <div>{answers.comment_section_optional}</div>}
                    {answers?.comment_section_optional_youth && <div>{answers.comment_section_optional_youth}</div>}
                  </>
                ) : (
                  "No Comments Available"
                )}
              </span>
            </div>
          </div>
          <div
            className="mb-2"
            style={{
              border: "1px solid",
              padding: "10px",
            }}
          >
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>Notes</div>
            {notesData?.length > 0 ? (
              notesData?.map((note, index) => (
                <div
                  key={index}
                  style={{
                    borderBottom: "1px solid #ddd",
                    padding: "5px 0",
                    fontSize: "12px",
                  }}
                >
                  <div>
                    <strong>User:</strong> {note?.userName}
                  </div>
                  <div>
                    <strong>Note:</strong> {note?.notes}
                  </div>
                  <div>
                    <strong>Date:</strong>{" "}
                    {new Date(note?.created_at).toLocaleString()}
                  </div>
                </div>
              ))
            ) : (
              <div style={{ fontSize: "12px", color: "gray" }}>
                No notes available
              </div>
            )}
          </div>


        </div>
      </div>
    </div>
  );
}
